import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "components/CreditCard/CreditCard";
import { SvgInline } from "components/SvgInline/SvgInline";

interface Props {
  cardName: string;
  cardEndsWith: string;
  isFraudLocked: boolean;
}

export const LockUnlockUnavailable = ({
  cardName,
  cardEndsWith,
  isFraudLocked,
}: Props) => (
  <Stack gap={8}>
    <Container bg="grey.t05" padding="4">
      <CreditCard {...{ cardName, cardEndsWith }} />
    </Container>
    <SvgInline name="third-party-authority" size="128" />
    <Text textStyle="heading4">Temporarily lock card</Text>
    <Text>
      {isFraudLocked
        ? "Sorry, this feature is currently unavailable. Your card is either blocked or is subject to other restrictions. Please contact us for further information."
        : "Sorry, this feature is currently unavailable. Please try again later."}
    </Text>
    <Link
      appearance="primary-button"
      variant="blue-button"
      href="/manage-account"
      newTab={false}
    >
      Manage account
    </Link>
  </Stack>
);
